// The locked house style for every creature sheet. Change these only on purpose:
// every sprite in the game is rendered with them (see STYLE.md).
import type { Facing } from './engine.ts';

/** Sheet columns: walk frames, then idle frames, then attack frames (ATK in creature.ts). */
export const WALK = 4, IDLE = 8;
/** Battle-sprite finish: near-black outline, hard drop shadow, punchy light bands. */
export const STYLE = { outline: '#08070c', inkMix: 0.88, drop: true, bands: [0.86, 0.48, 0.06] };
export const AURA_OUTLINE = '#14060f';
/** Sheet rows. */
export const FACINGS: Facing[] = ['front', 'left', 'back', 'right'];
